export const dropdownConfig = {
  foodRestriction: {
    placeholder: 'No Dietary Restrictions'
  },
  restaurantLocation: {
    placeholder: 'All Locations'
  }
  // Add more as needed
}

export type DropDownType = keyof typeof dropdownConfig

export const getPlaceholder = (type: string): string => {
  return dropdownConfig[type as DropDownType]?.placeholder || type || 'Select option'
}
